<template>
	<div class="layout-bsales">
		<header-principal class="header-principal"></header-principal>
		<div v-if="accessApp" class="content-main">
            <!-- <headerSecundary @returnEventHeader="actionHeader($event)"></headerSecundary> -->
            <menulateral v-if="getShowAside" @activarLateral="showAside = $event"></menulateral>
			<div v-if="getHeader" :class="[ 'page-wrapper', {show: showAside}]">
				<router-view></router-view>
			</div>
		</div>
		<footer-principal class="footer-principal"></footer-principal>
	</div>
</template>
<script>
// @ts-ignore
import { mapMultiGetters } from "@/core/utils/vuex";
import HeaderPrincipal from "@/core/views/Header";
import menulateral from "@/apps/bsales/views/Aside_bSales";
import FooterPrincipal from "@/core/views/Footer";
// import headerSecundary from "@/apps/bsales/components/headerSecundary";
export default {
    name: "bsalesLayout",
    components: {
        HeaderPrincipal,
        menulateral,
        FooterPrincipal,
        // headerSecundary
    },
    data() {
        return {
            component: 'menulateral',
            showAside: true,
        };
    },
    created() {
        if (this.loggedIn && this.getHeader) {
            //console.log('si hay login M');
            this.validAccess();
        }
    },
    methods: {
        validAccess() {
            let t = this;
            t.$store.dispatch("core/apps/validAccess").then((response) => {
                let App = response;
                if (App) {
                    //si tiene bsales asignado entonces permitir acceso
                    console.log("Accesso permitido");
                    t.$store.dispatch("ModApps/bsales/SetActive", App);
                } else {
                    t.$store.dispatch("ModApps/bsales/SetActive", App);
                    console.log("Accesso Negado");
                    t.$router.push({ name: "Home" });
                } //sino volver a home
            });
        },
        actionHeader(action){
            // event emitted from headerSecundary
            console.log('actionHeader', action)
        },
    },
    watch: {
        getHeader: function () {
            //console.log('getHeader ', this.getHeader);
            this.validAccess();
        },
        getShowAside: function (val) {
            this.showAside = val;
        },
    },
    computed: {
        ...mapMultiGetters([
            ["ModApps/bsales", {
                accessApp: "accessApp",
                getShowAside: "lateral",
            }],
            ["core", { getHeader: "getHeader" }],
            ["core/session", { loggedIn: "loggedIn" }]
        ]),
    },
};
</script>
<style scoped lang="scss">
.header {
    top: 0;
}
.page-wrapper {
    margin-left: 0px;
    z-index: initial !important;
}
.page-wrapper.show {
    margin-left: 105px !important;
}
</style>
